<template>
  <div class="author">
    <div class="container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Author',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.author {
  width: 100%;
  margin-top: 30px;
  margin-bottom: 30px;
  color: #7b7a7a;
  font-size: 1.06rem;
  line-height: 1.7;
  p, span {
    margin: 0;
    font-size: 1.06rem;
  }
}
</style>
